import { traceSteps } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

const criteria = [
  "以最早可检索的上传时间为准，而非热度最高的一条",
  "同一设备连拍的参数一致，可据此锁定最早外流节点",
  "二次搬运若改写标题，以原始链接与快照为准",
  "原帖删除后仍保留归档快照，用于回溯来源",
];

export default function TraceSection() {
  return (
    <section id="trace" className="w-full border-y border-background-200 bg-background-100">
      <div className="w-full px-4 py-10 md:px-6 md:py-14">
        <div className="mx-auto w-full max-w-[1220px]">
          <SectionHeading
            index="02"
            label="首发路径追踪"
            title="从拍摄到扩散：一条完整出处链条"
            desc="以事件 H-2418 为例，按时间顺序标注最早出现、首发出处、二次搬运与扩散高峰。"
          />

          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
            <div className="relative">
              {traceSteps.map((step, index) => {
                const isFirstPost = index === 1;
                const isLast = index === traceSteps.length - 1;
                return (
                  <div key={step.marker} className="relative pb-5 pl-9 last:pb-0">
                    {!isLast ? (
                      <span className="absolute left-[13px] top-7 h-full w-px bg-background-300"></span>
                    ) : null}
                    <span
                      className={`absolute left-0 top-1 flex h-7 w-7 items-center justify-center rounded-full border font-heading text-[11px] font-bold ${
                        isFirstPost
                          ? "border-accent-500 bg-accent-500 text-foreground-950"
                          : "border-background-300 bg-background-50 text-foreground-600"
                      }`}
                    >
                      {index}
                    </span>
                    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="zone-label rounded bg-background-200 px-2 py-0.5 text-[10px] text-foreground-700">
                          {step.time}
                        </span>
                        <span className="flex items-center gap-1 text-[11px] text-foreground-600">
                          <i className="ri-broadcast-line"></i>
                          {step.platform}
                        </span>
                        {isFirstPost ? (
                          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[10px] font-medium text-accent-800">
                            最可能首发出处
                          </span>
                        ) : null}
                      </div>
                      <div className="mt-2 flex items-baseline gap-2">
                        <h4 className="font-heading text-base font-bold text-foreground-950">{step.title}</h4>
                        <span className="text-[11px] text-foreground-500">{step.actor}</span>
                      </div>
                      <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{step.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <aside className="space-y-4">
              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className="ri-focus-3-line"></i>
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-950">判定依据</span>
                </div>
                <ul className="mt-3 space-y-2.5">
                  {criteria.map((text) => (
                    <li key={text} className="flex gap-2 text-xs leading-relaxed text-foreground-600">
                      <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500"></i>
                      <span>{text}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-200 text-foreground-700">
                    <i className="ri-map-pin-2-line"></i>
                  </span>
                  <span className="font-heading text-sm font-bold text-foreground-950">拍摄背景</span>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                  场地布置、当天活动流程与现场物料细节吻合，判断拍摄发生于一场公开活动现场的后台区域，非私人空间。相关时间线已一并归档。
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">公开活动</span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">后台区域</span>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-800">同批连拍</span>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}